import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { api } from "./utils/api";
import "./App.css";

// Bileşenleri İçe Aktar
import Login from "./pages/admin/Login";
import ResidentSetup from "./pages/resident/ResidentSetup";
import ResidentApp from "./pages/resident/ResidentApp";
import ResidentLogin from "./pages/resident/ResidentLogin";
import AdminApp from "./pages/admin/AdminApp"; 
import Balances from "./pages/admin/Balances";

// YENİ: Başkent Sitesi Web Portalı (src/portal klasörü)
import "./portal/portal.css";
import { Toaster } from "./portal/components/ui/sonner";
import { ResidentAuthProvider } from "./portal/context/ResidentAuth";
import SiteLayout from "./portal/components/site/SiteLayout";
import RequireResident from "./portal/components/site/RequireResident";
import HomePage from "./portal/pages/HomePage";
import AnnouncementsPage from "./portal/pages/AnnouncementsPage";
import AnnouncementDetailPage from "./portal/pages/AnnouncementDetailPage";
import AboutPage from "./portal/pages/AboutPage";
import ContactPage from "./portal/pages/ContactPage";
import PortalLoginPage from "./portal/pages/LoginPage";
import PaymentsPage from "./portal/pages/PaymentsPage";
import FeedbackPage from "./portal/pages/FeedbackPage";
import PaymentResultPage from "./portal/pages/PaymentResultPage";
import PortalAdminLoginPage from "./portal/pages/admin/AdminLoginPage";
import PortalAdminPanel from "./portal/pages/admin/AdminPanel";

export default function App() {
  const [user, setUser] = useState(null);
  const [resident, setResident] = useState(null);
  const [checking, setChecking] = useState(true);
  
  useEffect(() => {
    api.get("/auth/me")
       .then(r => setUser(r.data))
       .catch(() => {})
       .finally(() => setChecking(false));
  }, []);
  
  if (checking) return <div className="loading">Güvenli oturum kontrol ediliyor...</div>;
  
  return (
    <ResidentAuthProvider>
      <Routes>
        {/* ANA SAYFA - WEB PORTALI */}
        <Route element={<div className="portal-root"><SiteLayout /></div>}>
          <Route path="/" element={<HomePage />} />
          <Route path="/duyurular" element={<AnnouncementsPage />} />
          <Route path="/tebrik-taziye" element={<AnnouncementsPage fixed="taziye,tebrik" title="Tebrik & Taziye" />} />
          <Route path="/duyuru/:id" element={<AnnouncementDetailPage />} />
          <Route path="/sitemiz" element={<AboutPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/giris" element={<PortalLoginPage />} />
          <Route path="/odemeler" element={<RequireResident><PaymentsPage /></RequireResident>} />
          <Route path="/dilek-sikayet" element={<RequireResident><FeedbackPage /></RequireResident>} />
          <Route path="/odeme/sonuc" element={<RequireResident><PaymentResultPage /></RequireResident>} />
        </Route>
        {/* PORTAL YÖNETİM PANELİ (haber & duyurular) */}
        <Route path="/yonetim/giris" element={<div className="portal-root"><PortalAdminLoginPage /></div>} />
        <Route path="/yonetim" element={<div className="portal-root"><PortalAdminPanel /></div>} />

        <Route path="/balances" element={<Balances />} />
        {/* SAKİN (MALİK/KİRACI) YÖNLENDİRMESİ */}
        <Route path="/sakin/kurulum" element={<ResidentSetup />} />
        <Route path="/sakin/*" element={
          resident ? <ResidentApp resident={resident} /> : <ResidentLogin onLogin={setResident}/>
        }/>
        
        {/* YÖNETİCİ YÖNLENDİRMESİ (aidat takip programı) */}
        <Route path="/admin/*" element={
          user ? (
            <AdminApp 
              user={user} 
              onLogout={async () => {
                await api.post("/auth/logout");
                setUser(null);
              }} 
            />
          ) : <Login onLogin={setUser}/>
        }/>

        {/* Hatalı linklerde ana sayfaya (Portala) yönlendir */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </ResidentAuthProvider>
  );
}
